<template lang="pug">
.text
  div.text-header.text-23-b Политика конфиденциальности

  div.policy-content
    pre.policy-text.text-15
      | Настоящий документ «Политика конфиденциальности» (далее по тексту – «Политика») представляет собой правила использования Компанией полученной персональной информации Пользователя.
      |
      | 1. Термины и определения
      |
      | 1.1. В настоящем документе и вытекающих или связанных с ним отношениях Сторон применяются следующие термины и определения:
      | a. Правообладатель – Компания.
      | b. Пользователь – лицо, заключившее с Правообладателем Пользовательское соглашение в своем или чужом интересе в соответствии с требованиями действующего законодательства и Соглашения.
      | c. Договор – договор на безвозмездное использование Мобильного приложения, а также Сервиса (Пользовательское соглашение, далее – Соглашение), Лицензионный договор с конечным пользователем Мобильного приложения и/или иное соглашение с Правообладателем, предлагаемое к заключению и/или заключенное Пользователем на основании любой оферты, размещенной в Мобильном приложении.
      | d. Мобильное приложение – предназначенная для установки и использования на мобильном устройстве программа для ЭВМ, позволяющая пользоваться Сервисом.
      | e. Сервис – совокупность функциональных возможностей Мобильного приложения и размещенного в нем Контента, доступ к которым предоставляется Пользователю в информационных целях.
      |
      | 1.2. В настоящей Политике используются термины и определения, предусмотренные Соглашением, а также иными заключаемыми Пользователем Договорами, если иное не предусмотрено настоящей Политикой или не вытекает из ее существа. В иных случаях толкование применяемого в Политике термина производится в соответствии с действующим законодательством Российской Федерации, обычаями делового оборота.
      |
      | 2. Общие положения
      |
      | 2.1. Настоящая Политика является неотъемлемой частью ссылающихся на нее документов, в том числе Пользовательского соглашения, Лицензионного соглашения с конечным пользователем Мобильного приложения, и заключенных на их основе Договоров.
      |
      | 2.2. Используя Мобильное приложение, проходя регистрацию/авторизацию в Мобильном приложении, и/или заключая Договор вы свободно, своей волей и в своих интересах даете письменное согласие на следующие способы обработки Персональной информации: запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передача (предоставление, доступ), обезличивание, блокирование, удаление, уничтожение в целях и в порядке, установленных настоящей Политикой, с использованием средств автоматизации или без использования таких средств по усмотрению Правообладателя.
      |
      | 2.3. К настоящей Политике, включая толкование ее положений и порядок принятия, исполнения, изменения и прекращения, подлежит применению законодательство Российской Федерации.
      |
      | 3. Персональная информация
      |
      | 3.1. Под персональной информацией в настоящей Политике понимается:
      | 3.1.1. Информация, которую Пользователь предоставляет о себе самостоятельно при регистрации или авторизации в Мобильном приложении, а также в процессе иного использования Сервиса, включая персональные данные Пользователя (фамилия, имя, отчество, номер телефона, который был указан для работы с Компанией (далее – номер телефона), адрес электронной почты).
      | 3.1.2. Данные, которые передаются в автоматическом режиме в зависимости от настроек программного обеспечения Пользователя в обезличенном виде.
      |
      | 3.2. Правообладатель вправе устанавливать требования к составу Персональной информации Пользователя, которая должна обязательно предоставляться для использования Сервиса и/или заключения Договора путем указания такой информации. Если определенная информация не помечена Правообладателем как обязательная, ее предоставление или раскрытие осуществляется Пользователем на свое усмотрение.
      |
      | 3.3. Регистрация, аутентификация в Мобильном приложении Пользователем происходит по номеру телефона.
      | При использовании Сервиса Мобильным приложением устанавливается локализация устройства Пользователя (язык и страна), а при направлении Пользователем через Мобильное приложение запроса Правообладателю в рамках технической  поддержки дополнительно: модель устройства Пользователя, версия операционной системы, IP-адрес, MAC-адрес.
      | Правообладателю не передаются авторизационные данные, которые Пользователь использует для синхронизации Мобильного приложения с Компанией, все эти данные хранятся исключительно на устройстве Пользователя, на котором установлен экземпляр Мобильного приложения.
      |
      | 3.4. Правообладатель не осуществляет проверку достоверности предоставляемой Персональной информации и наличия у Пользователя необходимого согласия на ее обработку в соответствии с настоящей Политикой, полагая, что Пользователь действует добросовестно, осмотрительно и прилагает все необходимые усилия к поддержанию такой информации в актуальном состоянии и получению всех необходимых согласий субъектов персональных данных.
      |
      | 4. Цели обработки Персональной информации
      |
      | 4.1. Правообладатель осуществляет обработку, в том числе сбор и хранение только той Персональной информации, которая необходима для заключения и исполнения Договоров с Пользователем.
      | 4.2. Правообладатель вправе использовать Персональную информацию в целях:
      | 4.2.1. Заключения Соглашения на использование Сервиса, а равно заключения иных Договоров с использованием Сервиса.
      | Заключение Договоров осуществляется в дистанционном порядке посредством обмена электронными документами, которые подписываются простой электронной подписью.
      | 4.2.2. Аутентификация Пользователя в рамках исполнения обязательств по заключенным с ним Договорам.
      | Личный кабинет Пользователя привязан к номеру телефона Пользователя.
      | При направлении информации о заказе, предоставлении информационной и технической поддержки, Пользователь аутентифицируется по номеру телефона.
      | 4.2.3. Исполнение обязательств по заключенному Соглашению и иным Договорам, включая предоставление Пользователю доступа к Сервису и технической поддержки, использование Пользователем функциональных возможностей Сервиса.
      | В целях реализации соответствующих функциональных возможностей Сервиса, Правообладатель хранит, систематизирует и отображает в Мобильном приложении профили Пользователей, а также иную информацию, предоставленную Пользователем.
      | Для оказания технической поддержки используются данные о локализации устройства Пользователя (язык и страна), модель устройства, версия операционной системы, IP-адрес.
      | 4.2.4. Обеспечение безопасности и конфиденциальности Персональной информации Пользователя. В целях проверки подозрительных действий в Мобильном приложении собирается информация об используемом Пользователем IP-адресе, MAC-адресе и браузере.
      | 4.2.5. Обеспечение связи с Пользователем в целях информационного обслуживания в рамках Сервиса и улучшения качества Сервиса по заключенным Соглашению и иным договорам, в том числе в порядке нотификации с привлечением третьих лиц. Для этого запрашивается адрес электронной почты Пользователя.
      |
      | 5. Требования к защите Персональной информации
      |
      | 5.1. Правообладатель осуществляет хранение Персональной информации и обеспечивает ее охрану от несанкционированного доступа и распространения в соответствии с внутренними правилами и регламентами.
      | 5.2. В отношении Персональной информации Пользователя сохраняется ее конфиденциальность, за исключением Общедоступной информации.
      | 5.3. В целях повышения качества Сервиса, Правообладатель вправе хранить лог-файлы о действиях, совершенных Пользователем в рамках использования Сервиса, а также в связи с заключением и исполнением Пользователем Договоров со своей стороны, в течение 1 (Одного) года.
      |
      | 6. Передача информации
      |
      | 6.1. Правообладатель вправе передать Персональную информацию третьим лицам в следующих случаях:
      | •	Пользователь выразил свое согласие на такие действия, включая случаи применения Пользователем настроек используемого программного обеспечения, не ограничивающих предоставление определенной информации;
      | •	Передача требуется для заключения и исполнения Договоров с использованием Сервиса;
      | •	Передача необходима в рамках использования Пользователем функциональных возможностей Мобильного приложения;
      | •	В связи с использованием в Мобильном приложении программного обеспечения третьих лиц для реализации функциональных возможностей Мобильного приложения.
      | •	В связи с передачей Мобильного приложения Правообладателя во владение, пользование или собственность третьего лица, или уступкой прав по заключенным с Пользователем договорам в пользу третьего лица;
      | •	По запросу суда или иного уполномоченного государственного органа в рамках установленной законодательством процедуры;
      | •	Для защиты прав и законных интересов Правообладателя в связи с нарушением заключенных с Пользователем Договоров.
      |
      | 7. Изменение и удаление Персональной информации
      |
      | 7.1.	Пользователь вправе в любой момент самостоятельно отредактировать в своем Личном кабинете предоставленную им при регистрации или авторизации Персональную информацию.
      | 7.2.	В случае прекращения заключенного Соглашения и/или Договора, Пользователь вправе самостоятельно удалить собственный Личный кабинет, используя соответствующую функциональную возможность в Личном кабинете.
      |
      | E-mail: kiddiecoin2025@gmail.com
      |
      | Действующая редакция от «20» октября 2025 года
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  methods: {
    goBack() {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.container-banner {
  background: #FFEF9E;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.text {
  background: #FFFFFF;
  border-top-left-radius: 120px;
  border-top-right-radius: 120px;
  height: 100%;
  margin-top: 21px;
  display: flex;
  flex-direction: column;
  position: relative;
}

.text-header {
  margin-top: 48px;
  padding: 0 24px;
  text-align: center;
}

.policy-content {
  margin-top: 24px;
  padding: 0 20px;
  padding-bottom: 30px;
  flex: 1;
  overflow-y: auto;
}

.policy-text {
  font-size: 14px;
  line-height: 1.6;
  white-space: pre-wrap;
  color: #333;
}

.button-container {
  position: sticky;
  bottom: 0;
  background: #FFFFFF;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  justify-content: center;
}

button {
  width: 220px;
  height: 68px;
  border-radius: 60px;
  border: none;
  font-size: 16px;
}

.next {
  background: #F6514C;
  color: #FFFFFF;
}
</style>
